'use client';

import { useEffect, useState } from 'react';
import EventCardClient from './EventCardClient';
import Link from 'next/link';

type Event = {
  id: number;
  eventName: string;
  eventHost?: string;
  eventTheme?: string;
  startDate: string;
  endDate?: string;
  eventTime?: string;
  eventVenue?: string;
  eventImg?: string;
};

const useIsLargeScreen = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsLargeScreen(window.innerWidth >= 1025); 
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  return isLargeScreen;
};

const Eventcard = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const isLargeScreen = useIsLargeScreen();

  useEffect(() => {
    fetch('/api/events')
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        // Ensure data is an array
        if (Array.isArray(data)) {
          setEvents(data);
        } else {
          console.error('API did not return an array:', data);
          setEvents([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching events:', err);
        setError(err.message);
        setEvents([]);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p className="text-center text-gray-500">Loading events...</p>;
  }

  if (error) {
    return <p className="text-center text-red-500">Error loading events: {error}</p>;
  }

  // Safely slice only if events is an array
  const displayedEvents = Array.isArray(events) 
    ? (isLargeScreen ? events.slice(0, 3) : events)
    : [];

  return (
    <div className='md:px-12 lg:px-16 mb-6 mt-2 py-3'>
      <EventCardClient events={displayedEvents} />
    </div>
  );
};

export default Eventcard;